import { IncomingMessage } from 'http'

import { isGoogleBotAgent } from './is-google-bot'

export type ShouldConsumeViewCredits_Viewer = {
  boxProfileInfo: {
    linkedAccount: boolean | null
  } | null
}

export const shouldConsumeViewCredits = (
  req: IncomingMessage,
  viewer: ShouldConsumeViewCredits_Viewer | null
) => {
  const linkedAccount = viewer?.boxProfileInfo?.linkedAccount ?? false

  return !isGoogleBotAgent(req) && !!viewer && !linkedAccount
}
